module.exports = __webpack_public_path__ + "static/media/favicon.542058a5.ico";